export default "__VITE_ASSET__POB1jF91__"